<template>
    <div>
      <router-view/>
    </div>
</template>

<script>
  export default {
    name: 'mentionMeIndex'
  }
</script>

<style scoped>

</style>
